import React, { useState } from "react";
import { Button, Input, message } from "antd";
import { S3ServiceLambda } from "~/services/s3";
import * as APITypes from "~/API";
import { useAppTranslation } from "~/hooks/useAppTranslation";

export const UploadFileButton = ({
  currentUser,
  entityId,
  entityType,
}: {
  currentUser: string;
  entityId: string;
  entityType: APITypes.EntityType;
}) => {
  const { t } = useAppTranslation();
  const [file, setFile] = useState<File | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      var fileMb = e.target.files[0]?.size / 1024 ** 2;
      if (fileMb > 10) {
        alert(t("file_larger_than_10_MB"));
        setFile(null);
        e.target.value = "";
      } else {
        setFile(e.target.files[0]);
      }
    }
  };

  const upload = async () => {
    let fileName = (document.getElementById("fileName") as HTMLInputElement)
      .value;

    if (file === null) {
      message.error(t("No_file_selected"));
    } else {
      let whichFileName: string;
      if (fileName !== null && !(fileName.length === 0)) {
        //changed filename
        whichFileName = fileName;
      } else {
        // original filename
        whichFileName = file.name;
      }

      if (currentUser?.toString().length === 0) {
        message.error(t("Error_getting_account_data"));
      } else {
        try {
          const uploadFile = await S3ServiceLambda.upload({
            entityType: entityType,
            entityID: entityId,
            file: file,
            name: whichFileName,
          });

          if (uploadFile.success) {
            message.success(t("File_successfully_uploaded"));
          } else {
            console.error("Error uploading file", uploadFile.error);
            message.error(t("File_upload_failed"));
          }
        } catch (error) {
          console.error("Error uploading file", error);
          message.error("Failed to upload file");
        }
      }
    }
  };

  const handleKeyDown = (evt: React.KeyboardEvent<HTMLFormElement>) => {
    if (evt.key === "Enter") {
      evt.preventDefault();
      return false;
    }
  };

  return (
    <>
      <div className="input-group">
        <Button shape="round" style={{ gap: "0px" }}>
          <label htmlFor="file" style={{ margin: "0px", gap: "0px" }}>
            {t("Upload_file")}
          </label>
          <Input
            id="file"
            type="file"
            style={{ opacity: "0%", padding: "0px", width: "0px" }}
            accept=".pdf,.jpg, .png, .jpeg, .gif, .bmp, .svg, .tiff, .webp, .xls,.xlsx, .doc, .docx, .mp4"
            onChange={handleFileChange}
          />
        </Button>
      </div>
      <br />
      {file && (
        <form action="/action_page.php" onKeyDown={(evt) => handleKeyDown(evt)}>
          <section>
            {t("File_Details")}:
            <ul>
              <li>
                <label htmlFor="fileName">
                  {t("Name")}:{" "}
                </label>
                <Input
                  placeholder={file.name}
                  id="fileName"
                  name="fileName"
                  style={{ width: 150 }}
                />
              </li>
              <li>
                {t("Type")}: {file.type}
              </li>
              <li>
                {t("Size")}: {file.size}{" "}
                {t("bytes")}
              </li>
            </ul>
          </section>
        </form>
      )}
      {file && (
        <>
          <Button shape="round" onClick={upload}>
            {t("Submit")}
          </Button>
          <br />
        </>
      )}
    </>
  );
};
